import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: '100vh',
    background: '#f5f7fb',
  },
  topBar: {
    height: 70,
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    borderBottom: '1px solid #e7eaf0',
    padding: '0 32px',
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px',
      height: 62,
    },
  },
  content: {
    width: '100%',
    maxWidth: 1040,
    margin: '0 auto',
    padding: '34px 24px 48px',
    [theme.breakpoints.down('xs')]: {
      padding: '24px 16px 36px',
    },
  },
  pageTitle: {
    fontSize: 25,
    lineHeight: 1.3,
    fontWeight: 700,
    color: '#30336f',
  },
  subtitle: {
    marginTop: 6,
    color: '#7c8496',
    fontSize: 13,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 22,
  },
  refreshButton: {
    textTransform: 'none',
    borderRadius: 8,
    borderColor: '#d9deea',
    color: '#46516a',
    background: '#fff',
  },
  overviewCard: {
    border: '1px solid #e6eaf2',
    borderRadius: 12,
    boxShadow: '0 3px 12px rgba(31, 45, 75, 0.045)',
    overflow: 'hidden',
  },
  overviewTop: {
    padding: theme.spacing(2.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 16,
  },
  identity: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  identityIcon: {
    width: 48,
    height: 48,
    minWidth: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 11,
    color: '#5147b8',
    background: '#eeedff',
    marginRight: 14,
  },
  appName: {
    fontSize: 17,
    fontWeight: 700,
    color: '#29334b',
  },
  appCaption: {
    fontSize: 12,
    color: '#8791a3',
    marginTop: 3,
  },
  liveChip: {
    height: 28,
    borderRadius: 16,
    background: '#e6f7ed',
    color: '#16834c',
    fontWeight: 700,
    '& .MuiChip-icon': {
      color: '#16834c',
    },
  },
  downChip: {
    height: 28,
    borderRadius: 16,
    background: '#fff0f1',
    color: '#c43d50',
    fontWeight: 700,
    '& .MuiChip-icon': {
      color: '#c43d50',
    },
  },
  details: {
    padding: theme.spacing(2.25, 2.5),
    background: '#fbfcfe',
    borderTop: '1px solid #edf0f5',
  },
  detailLabel: {
    fontSize: 11,
    color: '#8791a3',
    marginBottom: 6,
  },
  detailValue: {
    fontSize: 13,
    color: '#344054',
    fontWeight: 600,
    overflowWrap: 'anywhere',
  },
  sectionHeading: {
    fontSize: 15,
    fontWeight: 700,
    color: '#303b53',
    marginTop: theme.spacing(3),
    marginBottom: 12,
  },
  infoCard: {
    minHeight: 88,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #e7ebf2',
    borderRadius: 10,
    boxShadow: '0 2px 8px rgba(31, 45, 75, 0.025)',
    background: '#fff',
  },
  infoIcon: {
    width: 38,
    height: 38,
    minWidth: 38,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9,
    color: '#5d63bd',
    background: '#f0f1ff',
    marginRight: 13,
  },
  infoLabel: {
    fontSize: 11,
    color: '#8791a3',
    marginBottom: 4,
    textTransform: 'capitalize',
  },
  infoValue: {
    fontSize: 13,
    color: '#344054',
    fontWeight: 600,
    overflowWrap: 'anywhere',
  },
  footer: {
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
    color: '#929bad',
    fontSize: 11,
  },
  statePaper: {
    padding: theme.spacing(5, 2),
    textAlign: 'center',
    border: '1px solid #e7ebf2',
    borderRadius: 10,
    background: '#fff',
  },
  errorIcon: {
    color: '#d64545',
    fontSize: 38,
  },
  errorText: {
    color: '#b42318',
    fontWeight: 600,
    marginTop: 10,
  },
}));